export default __webpack_public_path__ + "static/media/bg11.ecbc11f7.jpg";